import React, { useEffect, useState } from 'react';
import { FileText, Download, Search, Eye, Filter } from 'lucide-react';
import { documentoService } from '../services/api';
import './Documentos.css';

const CATEGORIAS = ['Todas', 'estatuto', 'ata', 'relatorio', 'contrato', 'certidao', 'outros'];

const catLabel: Record<string, string> = {
  estatuto: 'Estatuto', ata: 'Ata', relatorio: 'Relatório',
  contrato: 'Contrato', certidao: 'Certidão', outros: 'Outros'
};
const catBadge: Record<string, string> = {
  estatuto: 'badge-laranja', ata: 'badge-rosa', relatorio: 'badge-turquesa',
  contrato: 'badge-amarelo', certidao: 'badge-turquesa', outros: 'badge-amarelo'
};

export default function Documentos() {
  const [documentos, setDocumentos] = useState<any[]>([]);
  const [loading,    setLoading]    = useState(true);
  const [categoria,  setCategoria]  = useState('Todas');
  const [busca,      setBusca]      = useState('');

  useEffect(() => {
    const params: any = {};
    if (categoria !== 'Todas') params.categoria = categoria;
    documentoService.listar(params)
      .then(r => setDocumentos(Array.isArray(r.data) ? r.data : r.data.documentos || []))
      .catch(() => setDocumentos([]))
      .finally(() => setLoading(false));
  }, [categoria]);

  const filtrados = busca.trim()
    ? documentos.filter(d => d.titulo?.toLowerCase().includes(busca.toLowerCase()) || d.descricao?.toLowerCase().includes(busca.toLowerCase()))
    : documentos;

  return (
    <main>
      <div className="page-hero">
        <h1>portal do Instituto Mãos Estendidas</h1>
        <p>Acesse estatutos, atas, relatórios e documentos oficiais do Instituto Mãos Estendidas.</p>
      </div>

      {/* Info bar */}
      <div className="trans-info-bar">
        <div className="container">
          <div className="trans-info-grid">
            {[
              { icon: <FileText size={18}/>, label: 'CNPJ', value: '45.334.670/0001-82' },
              { icon: <FileText size={18}/>, label: 'Natureza', value: 'Organização Não Governamental' },
              { icon: <FileText size={18}/>, label: 'Sede', value: 'Marabá – Pará' },
              { icon: <FileText size={18}/>, label: 'Fundação', value: '31 de Julho de 2021' },
            ].map((info, i) => (
              <div className="trans-info-item" key={i}>
                {info.icon}
                <div>
                  <span className="trans-info-label">{info.label}</span>
                  <span className="trans-info-value">{info.value}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <section className="section-pad">
        <div className="container">
          {/* Filters */}
          <div className="doc-filters">
            <div className="search-box">
              <Search size={17} />
              <input
                type="text"
                placeholder="Buscar documento…"
                value={busca}
                onChange={e => setBusca(e.target.value)}
              />
            </div>
            <div className="cat-pills">
              {CATEGORIAS.map(c => (
                <button
                  key={c}
                  className={`cat-pill ${categoria === c ? 'active' : ''}`}
                  onClick={() => setCategoria(c)}
                >
                  {c === 'Todas' ? 'Todos' : catLabel[c] || c}
                </button>
              ))}
            </div>
          </div>

          {loading ? (
            <div className="loading-center"><div className="spinner" /><p>Carregando documentos…</p></div>
          ) : filtrados.length === 0 ? (
            <div className="loading-center">
              <Filter size={40} style={{ color: 'var(--borda)' }} />
              <p>Nenhum documento encontrado.</p>
            </div>
          ) : (
            <div className="doc-grid">
              {filtrados.map((d: any, i: number) => (
                <div className="doc-card" key={d._id} style={{ animationDelay: `${i * 0.05}s` }}>
                  <div className="doc-icon">
                    <FileText size={28} />
                  </div>
                  <div className="doc-body">
                    <div className="doc-top">
                      <span className={`badge ${catBadge[d.categoria] || 'badge-amarelo'}`}>
                        {catLabel[d.categoria] || d.categoria}
                      </span>
                      {d.ano && <span className="doc-ano">{d.ano}</span>}
                    </div>
                    <h4>{d.titulo}</h4>
                    {d.descricao && <p>{d.descricao}</p>}
                    <span className="doc-data">
                      Publicado em {new Date(d.criadoEm || d.updatedAt).toLocaleDateString('pt-BR')}
                    </span>
                  </div>
                  <div className="doc-actions">
                    {d.arquivoUrl && (
                      <>
                        <a href={d.arquivoUrl} target="_blank" rel="noopener noreferrer" className="doc-btn doc-btn-view" title="Visualizar">
                          <Eye size={16} />
                        </a>
                        <a href={d.arquivoUrl} download className="doc-btn doc-btn-dl" title="Download">
                          <Download size={16} />
                        </a>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
